import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Button, Spinner, Modal, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { getLocalityListById, saveLocalityData, updateLocalityData } from "../../redux/actions/LocalityActions";
import FormInput from "../FormInput";
import { logout } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import Select from "react-dropdown-select";
import swal from 'sweetalert2';
import { getAllCityStateWiseList, getAllStateList } from "../../redux/actions/MasterActions";
import Preloader from "../Preloader";
import { LoadScript, Autocomplete } from "@react-google-maps/api";
import '../../styles/common.css'

const API_KEY = "AIzaSyD5L3M2Nl4wn3coWVJlI06RjT50l44FMu8";

const AddLocality = ({ show, onHide, editId }) => {
  const { t } = useTranslation();
  const [showModel, setShowModel] = useState(null);
  const [stateId, setStateId] = useState(null);
  const [placeData, setPlaceData] = useState({});
  const [formData, setFormData] = useState({});
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth, loading, errors },
    localityReducer: {
      loadingLocality,
      errorsLocality,
      localityLists,
      changedLocalityStatus,
    },
    masterReducer: {
      loadingMaster,
      masterStateLists,
      masterCityStateWiseLists,
    },
  } = useSelector((state) => state);

  const [validated, setValidated] = useState(false);
  

  useEffect(() => {
    setFormData({})
    if(editId) {
      dispatch(getLocalityListById(auth?.token, editId));
    }
  }, [auth, editId]);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
    if(editId){
      dispatch(updateLocalityData(auth?.token, formData, editId));
    } else {
      dispatch(saveLocalityData(auth?.token, formData));
    }
  };

  
  useEffect(() => {
    if(editId && localityLists && Object.keys(localityLists).length > 0) {
      setFormData({
        name: localityLists?.name,
      });
    }
  }, [localityLists]);

  useEffect(() => {
    if (errors && Object.keys(errors).length > 0 && errors?.status === 401) {
      dispatch(logout());
      toast.error(errors?.data?.message);
      onHide(); // Close modal on logout
    }
  }, [errors, dispatch, onHide]);


  const inputHandler = (e) => {
    const { value, name } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  
  useEffect(() => {
    if (changedLocalityStatus?.success) {
    onHide()
      swal.fire({
        show: true,
        title: "Well done!",
        text: changedLocalityStatus?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_DELETE_LOCALITY_STATUS' });
    }
  }, [changedLocalityStatus, dispatch]);


  return (
    <Modal show={show} onHide={onHide} size="md" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{(editId && localityLists && Object.keys(localityLists).length > 0) ? t("Update Locality") : t("Add Locality")}</Modal.Title>
      </Modal.Header>
        <Modal.Body>
            {errorsLocality?.data?.message && (
              <div className="alert alert-danger">
                {errorsLocality?.data?.message}
              </div>
            )}
          <Row>
          
            <Col lg={12}>
                <FormInput
                  label={t("Locality Name")}
                  type="text"
                  errors={errorsLocality?.data}
                  value={formData.name}
                  name="name"
                  required={true}
                  onChange={inputHandler}
                  containerClass={"mb-3"}
                  disabled={!!editId}
                />
              </Col>
          </Row>
          <div className="d-flex justify-content-center">
            {loading ? 
              <Button color="primary" disabled>
                <Spinner animation="border" size="sm" />
                {t("Please wait ...")}
              </Button>
            :
              <Button type="button" onClick={(e) => handleSubmit(e)} disabled={loading}>
              {(editId && localityLists && Object.keys(localityLists).length > 0) ? t("Update") : t("Add")}
              </Button>
            }
          </div>
        
      </Modal.Body>
      {loadingLocality && <Preloader />}
    </Modal>
  );
};

export default AddLocality;
